package com.daytimegaming.ourdailyfinances.presentation.navigation

import androidx.navigation3.runtime.NavKey
import kotlinx.serialization.Serializable

@Serializable
sealed class AppRoute : NavKey {
    @Serializable data object AddRealEstateHolding : AppRoute()
    @Serializable data class ViewRealEstateHolding(val realEstateHoldingId: String) : AppRoute()
    @Serializable data class UpdateRealEstateHolding(val realEstateHoldingId: String) : AppRoute()
    @Serializable data class AccountDetail(val accountId: String, val dashboardId: String? = null) : AppRoute()
    @Serializable data class SecurityHoldingDetail(val accountId: String, val securityId: String, val dashboardId: String? = null) : AppRoute()
    @Serializable data class CategorySpending(val categoryName: String, val range: String) : AppRoute()
    @Serializable data class ConfigureDashboard(val dashboardId: String) : AppRoute()
    @Serializable data class DashboardDetail(val dashboardId: String) : AppRoute()
    @Serializable data class DashboardTransactions(val dashboardId: String) : AppRoute()
    @Serializable data class RecurringTransactionDetail(val streamId: String) : AppRoute()
    @Serializable data class TransactionDetail(val transactionId: String, val dashboardId: String? = null) : AppRoute()
    @Serializable data class UpdateBudget(val budgetId: String) : AppRoute()
    @Serializable data class UpdateUserInfo(val email: String) : AppRoute()
    @Serializable data class ViewBudget(val budgetId: String) : AppRoute()
    @Serializable data object CreateBudget : AppRoute()
    @Serializable data object CreateDashboard : AppRoute()
    @Serializable data class Home(val tab: String = "dashboards") : AppRoute()
    @Serializable data object JoinDashboard : AppRoute()
    @Serializable data object Login : AppRoute()
    @Serializable data object ManageAccounts : AppRoute()
    @Serializable data object RecentSpending : AppRoute()
    @Serializable data object RecurringTransactions : AppRoute()
    @Serializable data object IncomeVsExpensesSummary : AppRoute()
    @Serializable data class MonthlyBreakdown(val yearMonth: String) : AppRoute()
    @Serializable data object Register : AppRoute()
    @Serializable data object Splash : AppRoute()
    @Serializable data object Landing : AppRoute()
    @Serializable data object ManageSubscription : AppRoute()
    @Serializable data object PrivacyPolicy : AppRoute()
    @Serializable data object TermsOfService : AppRoute()
}

